<template>
  <div id="fish">
    <div data-v-738a24f7="" class="bg-animation">
      <img loading="lazy"
        src="../../static/image/pn/fish5.png"
        width="130"
        class="cloud cloud-5"
      /><img loading="lazy"
        src="../../static/image/pn/fish2.png"
        width="90"
        class="cloud cloud-2"
      /><img loading="lazy"
        src="../../static/image/pn/fish3.png"
        width="110"
        class="cloud cloud-3"
      /><img loading="lazy"
        src="../../static/image/pn/fish4.png"
        width="100"
        class="cloud cloud-4"
      /><img loading="lazy"
        src="../../static/image/pn/fish1.png"
        width="140"
        class="cloud cloud-1"
      /><img loading="lazy"
        src="../../static/image/pn/fish6.png"
        width="110"
        class="cloud cloud-6"
      />
    </div>

    <div class="main">
      <ul>
        <li class="item" v-for="(item, index) in list" :key="index" @click="getToken(item,1)">
          <div class="nomal"></div>
            <div class="active"></div>
            <div class="title">{{item.name}}</div>
            <div class="img">
              <img loading="lazy" v-lazy="item.imgUrl?item.imgUrl:assetsList[0].img" alt="">
            </div>
            <a class=" active"> 
              {{$t('secondGame.enter')}}
            </a>
        </li>
      </ul>
      <!-- <div class="swiper">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="item" @click="getToken(item,1)">
              <div class="nomal"></div>
              <div class="active"></div>
              <div class="title">{{item.name}}</div>
              <div class="img">
                <img loading="lazy" v-lazy="assetsList[index%assetsList.length].img" alt="">
              </div>
              <a class=" active"> 
                {{$t('secondGame.enter')}}
              </a>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "component_name",
  data() {
    return {
      swiperOptions: {
        // loop: true,
        slidesPerView: 5,
        // spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
        },
        speed: 400,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      list: [],
      assetsList: [
        // 鱼的图片列表
        { img: require("@/assets/images/mb/fish1.png") },
        { img: require("@/assets/images/mb/fish2.png") },
        { img: require("@/assets/images/mb/fish3.png") },
        { img: require("@/assets/images/mb/fish4.png") },
        { img: require("@/assets/images/mb/fish5.png") },
        { img: require("@/assets/images/mb/fish6.png") },
      ],
    };
  },
  mounted() {
    this.getDataType();
  },
  methods: {
    // 获取数据列表
    getDataType() {
      let result = JSON.parse(localStorage.getItem("game_menus_pc"));
      this.list = result.data.by;
    },
    // 进入游戏
    getToken: async function (req, index) {
      // return
      let self = this;
      var issafariBrowser =
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent);

      if (!self.$common.getUser()) {
        self.$message.warning("请登录");
        return;
      }
      self.tenantId = self.$common.getUser().tenant_id;
      self.username = self.$common.getUser().username;
      self.uid = self.$common.getUser().user_id;
      let datas = {
        tenantId: self.tenantId,
        username: self.username,
        gameId: index == 2 ? req.ids : req.id,
        clientIp: self.$config.clientIp,
        memberId: self.uid,
        terminalType: 1,
      };
      self.$common.setGameRequestData(datas);

      const res = await self.$http.post(this.$api.getToken, datas, true);
      if (res.code == 0) {
        self.gameUrl = res.data;
        if (req.openMode === 1) {
          // if(issafariBrowser) {
          //  self.winOpen.location.href = self.gameUrl;
          // }else{
          window.open(self.gameUrl);
          // }
        } else {
          window.open(self.gameUrl);
        }
      } else {
        if (req.openMode === 1) {
          window.open("/error.html?type=1");
          // self.winOpen.location.href = '/error.html?type=1';
        }

        if (req.status === 0) {
          self.$message.error("维护中");
        } else {
          self.$message.error("进入游戏失败，请稍后重试！");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#fish {
  width: 100%;
  min-height: 892px;
  position: relative;
  overflow: hidden;
  background: url(../../static/image/pn/fishBg.jpg) no-repeat top;
  .bg-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .cloud {
      position: absolute;
    }
    .cloud-5 {
      animation: cloud-5 50s linear 1s infinite;
    }
    .cloud-1 {
      animation: cloud-1 50s linear 1s infinite;
    }
    .cloud-2 {
      animation: cloud-2 50s linear 1s infinite;
      transform: rotateY(180deg);
    }
    .cloud-3 {
      animation: cloud-3 50s linear 1s infinite;
    }
    .cloud-4 {
      animation: cloud-4 50s linear 1s infinite;
      transform: rotateY(180deg);
    }
    .cloud-6 {
      transform: rotateY(180deg);
      animation: cloud-6 50s linear 1s infinite;
    }
  }
  .main {
    margin: 550px auto 0;
    position: relative;
    overflow: hidden;
    // background: #050505;
    text-align: center;
    ul {
      width: 1260px;
      // max-height: 480px;
      // overflow-y: auto;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      .item {
        position: relative;
        cursor: pointer;
        background-color: #fff;
        width: 200px;
        height: 240px;
        margin: 0 10px 10px 0;
        .nomal {
          display: block;
          width: 200px;
          height: 240px;
          // background:linear-gradient(45deg,rgba(154, 192, 199, 0.4) 0%,rgb(152, 173, 241) 100%);
          background: url("../../assets/images/mb/fishing_bg.png") no-repeat;
          background-size: cover;
        }
        .active {
          display: none;
          width: 200px;
          height: 240px;
          // background:linear-gradient(45deg,rgba(230, 7, 144, 0.4) 0%,rgb(236, 13, 43) 100%);
          background: url("../../assets/images/mb/fishing_bg_active.png")
            no-repeat;
          background-size: cover;
        }
        .title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 24px;
          position: absolute;
          left: 0;
          top: 0;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          box-sizing: border-box;
          padding: 0 10px;
        }
        .img {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 185px;
          z-index: 1;
          img {
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
      }

      .item:hover {
        .nomal {
          display: none;
        }
        .active {
          display: block;
        }
        a {
          position: absolute;
          width: 100%;
          z-index: 999;
          background: #990019;
          bottom: 0;
          text-align: center;
          font-size: 14px;
          height: 40px;
          color: #fff;
          line-height: 40px;
          // -moz-opacity: 0.75;
          opacity: 0.75;
          // filter: alpha(opacity=75);
          font-weight: 600;
          transition: all 0.1s ease-in;
          -moz-transition: all 0.1s ease-in;
          -ms-transition: all 0.1s ease-in;
          -o-transition: all 0.1s ease-in;
          -webkit-transition: all 0.1s ease-in;
          // display: none;
        }

        a:hover {
          opacity: 0.95;
          // filter: alpha(opacity=95);
          height: 48px;
          background: #990019;
          line-height: 48px;
          font-size: 14px;
        }
      }
    }

    // .swiper {
    //   width: 1310px;
    //   margin: 0 auto;
    // }
    // .swiper-button-next,
    // .swiper-container-rtl .swiper-button-prev {
    //   right: 20px;
    //   width: 20px;
    //   height: 20px;
    //   background-color: transparent;
    //   background-size: 20px 44px;
    // }
    // .swiper-button-prev,
    // .swiper-container-rtl .swiper-button-next {
    //   left: 20px;
    //   width: 20px;
    //   height: 20px;
    //   background-color: transparent;
    //   background-size: 20px 44px;
    // }
    // .swiper-button-next.swiper-button-disabled,
    // .swiper-button-prev.swiper-button-disabled {
    //   visibility: hidden;
    // }
    // .swiper-button-prev {
    //   width: 50px;
    //   height: 50px;
    //   background: url("../../assets/images/mb/left-icon.png") no-repeat;
    //   background-size: 50px 50px;
    // }
    // .swiper-button-next {
    //   width: 50px;
    //   height: 50px;
    //   background: url("../../assets/images/mb/right-icon.png") no-repeat;
    //   background-size: 50px 50px;
    // }
    // .item {
    //   position: relative;
    //   cursor: pointer;
    //   background-color: #fff;
    //   width: 262px;
    //   height: 320px;
    //   .nomal {
    //     display: block;
    //     width: 262px;
    //     height: 320px;
    //     // background:linear-gradient(45deg,rgba(154, 192, 199, 0.4) 0%,rgb(152, 173, 241) 100%);
    //     background: url("../../assets/images/mb/fishing_bg.png") no-repeat;
    //     background-size: cover;
    //   }
    //   .active {
    //     display: none;
    //     width: 262px;
    //     height: 320px;
    //     // background:linear-gradient(45deg,rgba(230, 7, 144, 0.4) 0%,rgb(236, 13, 43) 100%);
    //     background: url("../../assets/images/mb/fishing_bg_active.png")
    //       no-repeat;
    //     background-size: cover;
    //   }
    //   .title {
    //     width: 100%;
    //     height: 40px;
    //     line-height: 40px;
    //     font-size: 24px;
    //     position: absolute;
    //     left: 0;
    //     top: 30px;
    //     color: #fff;
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     white-space: nowrap;
    //     text-align: left;
    //     box-sizing: border-box;
    //     padding-left: 15px;
    //     padding-right: 15px;
    //   }
    //   .img {
    //     position: absolute;
    //     left: 0;
    //     bottom: 0;
    //     width: 262px;
    //     height: 202px;
    //     z-index: 1;
    //     img {
    //       width: 100%;
    //       height: 100%;
    //       object-fit: cover;
    //     }
    //   }
    // }

    // .item:hover {
    //   .nomal {
    //     display: none;
    //   }
    //   .active {
    //     display: block;
    //   }
    //   a {
    //     position: absolute;
    //     width: 100%;
    //     z-index: 999;
    //     background: #990019;
    //     bottom: 0;
    //     text-align: center;
    //     font-size: 14px;
    //     height: 40px;
    //     color: #fff;
    //     line-height: 40px;
    //     // -moz-opacity: 0.75;
    //     opacity: 0.75;
    //     // filter: alpha(opacity=75);
    //     font-weight: 600;
    //     transition: all 0.1s ease-in;
    //     -moz-transition: all 0.1s ease-in;
    //     -ms-transition: all 0.1s ease-in;
    //     -o-transition: all 0.1s ease-in;
    //     -webkit-transition: all 0.1s ease-in;
    //     // display: none;
    //   }

    //   a:hover {
    //     opacity: 0.95;
    //     // filter: alpha(opacity=95);
    //     height: 48px;
    //     background: #990019;
    //     line-height: 48px;
    //     font-size: 14px;
    //   }
    // }
  }
}

@keyframes cloud-5 {
  0% {
    left: -150px;
    top: 5%;
  }
  10% {
    left: 10%;
    top: 8%;
  }
  20% {
    left: 20%;
    top: 5%;
  }
  30% {
    left: 30%;
    top: 8%;
  }
  40% {
    left: 40%;
    top: 5%;
  }
  50% {
    left: 50%;
    top: 8%;
  }
  60% {
    left: 60%;
    top: 5%;
  }
  70% {
    left: 70%;
    top: 8%;
  }
  80% {
    left: 80%;
    top: 5%;
  }
  90% {
    left: 90%;
    top: 8%;
  }
  100% {
    left: 100%;
    top: 5%;
  }
}
@keyframes cloud-2 {
  0% {
    left: 100%;
    top: 45%;
  }
  10% {
    left: 90%;
    top: 42%;
  }
  20% {
    left: 80%;
    top: 45%;
  }
  30% {
    left: 70%;
    top: 42%;
  }
  40% {
    left: 60%;
    top: 45%;
  }
  50% {
    left: 50%;
    top: 42%;
  }
  60% {
    left: 40%;
    top: 45%;
  }
  70% {
    left: 30%;
    top: 42%;
  }
  80% {
    left: 20%;
    top: 45%;
  }
  90% {
    left: 10%;
    top: 42%;
  }
  100% {
    left: -50px;
    top: 45%;
  }
}

@keyframes cloud-3 {
  0% {
    left: -150px;
    top: 65%;
  }
  10% {
    left: 8%;
    top: 68%;
  }
  20% {
    left: 20%;
    top: 65%;
  }
  30% {
    left: 32%;
    top: 68%;
  }
  40% {
    left: 44%;
    top: 65%;
  }
  50% {
    left: 56%;
    top: 68%;
  }
  60% {
    left: 68%;
    top: 65%;
  }
  70% {
    left: 80%;
    top: 68%;
  }
  80% {
    left: 92%;
    top: 65%;
  }
  90% {
    left: 104%;
    top: 68%;
  }
  100% {
    left: 110%;
    top: 65%;
  }
}
@keyframes cloud-4 {
  0% {
    left: 70%;
    top: 20%;
  }
  9% {
    left: 59%;
    top: 17%;
  }
  18% {
    left: 48%;
    top: 20%;
  }
  27% {
    left: 37%;
    top: 17%;
  }
  36% {
    left: 26%;
    top: 20%;
  }
  45% {
    left: 15%;
    top: 17%;
  }
  54% {
    left: 4%;
    top: 20%;
  }
  62% {
    left: -120px;
    opacity: 1;
    top: 17%;
  }
  63% {
    left: -160px;
    opacity: 0;
    top: 20%;
  }
  63.1% {
    left: 100%;
    opacity: 0;
    top: 20%;
  }
  72% {
    left: 100%;
    opacity: 1;
    top: 17%;
  }
  81% {
    left: 90%;
    top: 20%;
  }
  90% {
    left: 80%;
    top: 17%;
  }
  100% {
    left: 70%;
    top: 20%;
  }
}
@keyframes cloud-1 {
  0% {
    left: 20%;
    top: 27%;
  }
  10% {
    left: 35%;
    top: 30%;
  }
  20% {
    left: 50%;
    top: 27%;
  }
  30% {
    left: 65%;
    top: 30%;
  }
  40% {
    left: 80%;
    top: 27%;
  }
  50% {
    left: 95%;
    top: 30%;
  }
  60% {
    left: 110%;
    opacity: 1;
    top: 27%;
  }
  70% {
    left: 110%;
    opacity: 0;
    top: 27%;
  }
  70.1% {
    left: -140px;
    opacity: 0;
    top: 30%;
  }
  80% {
    left: 0;
    opacity: 1;
    top: 27%;
  }
  90% {
    left: 10%;
    top: 30%;
  }
  100% {
    left: 20%;
    top: 27%;
  }
}
@keyframes cloud-6 {
  0% {
    left: 50%;
    top: 50%;
  }
  8% {
    left: 40%;
    top: 53%;
  }
  16% {
    left: 30%;
    top: 50%;
  }
  24% {
    left: 20%;
    top: 53%;
  }
  32% {
    left: 10%;
    top: 50%;
  }
  40% {
    left: 0;
    top: 53%;
  }
  47% {
    left: -160px;
    opacity: 1;
    top: 50%;
  }
  48% {
    left: -160px;
    opacity: 0;
    top: 50%;
  }
  48.1% {
    left: 100%;
    opacity: 0;
    top: 50%;
  }
  56% {
    left: 100%;
    opacity: 1;
    top: 53%;
  }
  64% {
    left: 91%;
    top: 50%;
  }
  72% {
    left: 82%;
    top: 53%;
  }
  80% {
    left: 73%;
    top: 50%;
  }
  88% {
    left: 64%;
    top: 53%;
  }
  100% {
    left: 50%;
    top: 50%;
  }
}
</style>
